// extracted by mini-css-extract-plugin
export var eyebrow = "_kk-3";
export var heroImage = "_kk-4";
export var main = "_kk-2";
export var modal = "_kk-0";
export var shell = "_kk-1";